"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { DataBuilderFormulaType } from '@integration-app/sdk';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { useIntegrationAppClient } from '../../../contexts/integration-app-client-context.mjs';
import { useIntegrationAppConnection } from '../../../contexts/integration-app-connection-context.mjs';
import { ComboBoxTag } from '../../ComboBoxElements/ComboBoxTag.mjs';
import { Truncate } from '../../Truncate/index.mjs';
import useDataBuilder from '../data-builder-context.mjs';
import { makeSubField } from '../data-field.mjs';
import useDataBuilderField from '../field-context.mjs';
import { DataLinkTablesOptionsFactory } from '../../DataLinks/data-link-tables-option-factory.mjs';
import DataBuilderFormField from '../Field.mjs';

const FindExternalRecordIdFormula = forwardRef(
  (_props, ref) => {
    return /* @__PURE__ */ jsx(ComboBoxTag, { ref, icon: SvgIconType.Array, variant: "lookup", children: /* @__PURE__ */ jsx(Truncate, { children: "Find External Record ID" }) });
  }
);
function FindExternalRecordIdFormulaDropdown({
  formula,
  onChange
}) {
  const { field } = useDataBuilderField();
  const { client } = useIntegrationAppClient();
  const { connectionId } = useIntegrationAppConnection();
  const { isAdminMode } = useDataBuilder();
  if (formula?.type !== DataBuilderFormulaType.FIND_EXTERNAL_RECORD_ID) {
    return /* @__PURE__ */ jsx("span", { children: "Unexpected value for drilldown. Something went wrong." });
  }
  const args = formula.args ?? {};
  const { dataLinkTable, recordId } = args;
  function handleChange(value) {
    onChange?.({
      $findExternalRecordId: {
        ...args,
        ...value
      }
    });
  }
  function handleDataLinkTableKeyChange(value) {
    handleChange({
      dataLinkTable: {
        key: value
      }
    });
  }
  function handleRecordIdChange(value) {
    handleChange({
      recordId: value
    });
  }
  function makeDataLinkTableField() {
    return makeSubField(field, {
      valueLocator: `${field.valueLocator}.dataLinkTable.key`,
      value: dataLinkTable?.key,
      schema: { type: "string", title: "Data Link Table" },
      optionFactories: [
        new DataLinkTablesOptionsFactory({
          client,
          connectionId,
          /* FIXME: strictNullCheck temporary fix */
          // @ts-expect-error TS(2322): Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
          isAdminMode
        })
      ],
      exampleVariables: null,
      variablesSchema: null,
      level: 1,
      /* FIXME: strictNullCheck temporary fix */
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string | un... Remove this comment to see the full error message
      key: null,
      isInSchema: true
    });
  }
  function makeRecordIdField() {
    return makeSubField(field, {
      valueLocator: `${field.valueLocator}.$findExternalRecordId.recordId`,
      schema: { type: "string", title: "App Record Id" },
      optionFactories: field.optionFactories,
      exampleVariables: field.exampleVariables,
      variablesSchema: field.variablesSchema,
      level: 1,
      /* FIXME: strictNullCheck temporary fix */
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string | un... Remove this comment to see the full error message
      key: null,
      value: recordId,
      isInSchema: true
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      DataBuilderFormField,
      {
        field: makeDataLinkTableField(),
        onChange: handleDataLinkTableKeyChange
      }
    ),
    /* @__PURE__ */ jsx(DataBuilderFormField, { field: makeRecordIdField(), onChange: handleRecordIdChange })
  ] });
}

export { FindExternalRecordIdFormulaDropdown, FindExternalRecordIdFormula as default };
